/*
 * Copyright (c) 2025-present TechDivision GmbH
 * All rights reserved
 *
 * This product includes proprietary software developed at TechDivision GmbH, Germany
 * For more information see https://www.techdivision.com/
 *
 * To obtain a valid license for using this software please contact us at
 * license@techdivision.com
 */

import { formatMoneyWithCurrency } from '@theme/money-formatting';

class RewardPoints extends HTMLElement {
  constructor() {
    super();
    this.render();
  }

  getPrice() {
    return this.dataset.price / 100;
  }

  getConversionRateTo() {
    return (this.dataset.conversionRateTo || 1) * 1;
  }

  getConversionRateFrom() {
    return (this.dataset.conversionRateFrom || 1) * 1;
  }

  getTemplate() {
    return this.dataset.template;
  }

  getCurrentCurrencyRate() {
    return Shopify.currency.rate * 1 || 1;
  }

  getPointsByMoney(money) {
    const conversionRate = this.getConversionRateTo();
    const currencyRate = this.getCurrentCurrencyRate();
    return Math.floor(Math.floor(money) / currencyRate * conversionRate);
  }

  getMoneyByPoints(points) {
    const conversionRate = this.getConversionRateFrom();
    const currencyRate = this.getCurrentCurrencyRate();
    const money = (points / 100) * (conversionRate / 100) * currencyRate;
    return Math.round(money * 100) / 100;
  }

  renderPlaceholders(template, data) {
    return template.replace(
      /{{\s*(\w+)\s*}}/g,
      (match, key) => typeof data[key] !== 'undefined' ? data[key] : match
    );
  }

  render() {
    // reset
    this.setAttribute('data-loaded', 'true');

    // calculate
    const productPrice = this.getPrice();
    const points = this.getPointsByMoney(productPrice);
    const money = formatMoneyWithCurrency(this.getMoneyByPoints(points));

    // find text container
    let textContainer = this.querySelector('.popup-link > button > span');
    if (!textContainer) {
      textContainer = this.querySelector('.reward_points_inner');
      if (!textContainer) {
        textContainer = document.createElement('div');
        textContainer.classList.add('reward_points_inner');
        this.append(textContainer);
      }
    }

    // add text
    textContainer.innerHTML = this.renderPlaceholders(this.getTemplate(), { points, money });
  }
}

customElements.define('reward-points', RewardPoints);
